/*
 * ------------------------------------------------------------------
 * Cofá – Presentfunktion (v1.2)
 *
 * Ansvar:
 *   1. Popup på produktsidan: lägg till / ändra / ta bort presentinslagning.
 *   2. "Cart guard" som körs på alla sidor och håller varukorgen ren:
 *        - bara EN presentrad får finnas
 *        - presentraden får aldrig ha kvantitet > 1
 *        - presentraden tas bort om den är ensam kvar i varukorgen
 *        - cart attribute "Gift" speglar alltid verkligheten
 *   3. Neutraliserar länkar till presentprodukten i varukorgen, så att
 *      kunden inte kan klicka sig in på produktsidan och lägga till en
 *      andra presentrad utan hälsning.
 *
 * Sanningskällan är alltid /cart.js – inget eget state i localStorage.
 * Alla anrop går via routes från Liquid, så /en och /ar fungerar.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var cfg = window.CofaGift && window.CofaGift.config;
  if (!cfg) return;

  var S = cfg.strings;
  var R = {
    add: cfg.routes.add + '.js',
    change: cfg.routes.change + '.js',
    update: cfg.routes.update + '.js',
    cart: cfg.routes.cart + '.js'
  };

  var syncing = false;

  /* ---------------------------------------------------------------- */
  /* Hjälpare                                                          */
  /* ---------------------------------------------------------------- */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || 'Cart error');
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isGift(item) {
    return String(item.variant_id) === String(cfg.variantId) || item.handle === cfg.handle;
  }

  function giftLines(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(isGift);
  }

  function giftLine(cart) {
    return giftLines(cart)[0] || null;
  }

  function hasMessage(item) {
    if (!item || !item.properties) return false;
    return !!(item.properties[cfg.keys.message] || item.properties[cfg.keys.recipient]);
  }

  function otherUnits(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      return isGift(item) ? total : total + item.quantity;
    }, 0);
  }

  /* Tar bort HTML och kapar längden – värdet visas senare i mejl och på följesedel. */
  function clean(value, max) {
    return String(value == null ? '' : value)
      .replace(/<[^>]*>/g, '')
      .replace(/[<>]/g, '')
      .trim()
      .slice(0, max);
  }

  /* ---------------------------------------------------------------- */
  /* Länkar till presentprodukten i varukorgen                         */
  /* ---------------------------------------------------------------- */

  /*
   * Presentprodukten är "Ej listad" men har fortfarande en publik URL, och
   * temat länkar radens titel och bild dit. Därifrån skulle kunden kunna
   * lägga till en till presentrad – utan hälsning. Vi tar bort href:en
   * i stället för att skriva om temats cart-mallar.
   */
  function neutralizeGiftLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[href*="/' + cfg.handle + '"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.closest('[data-cofa-gift]')) continue;
      link.removeAttribute('href');
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-disabled', 'true');
      link.classList.add('cofa-gift-nolink');
    }
  }

  /* ---------------------------------------------------------------- */
  /* Rendering av temats cart-sektioner (Section Rendering API)        */
  /* ---------------------------------------------------------------- */

  function sectionsToRender() {
    var source =
      document.querySelector('cart-drawer-items') ||
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer');

    if (source && typeof source.getSectionsToRender === 'function') {
      try {
        var list = source.getSectionsToRender();
        if (list && list.length) return list;
      } catch (e) {
        /* CartItems kastar om #main-cart-items saknas – vi faller tillbaka nedan. */
      }
    }

    return document.getElementById('cart-icon-bubble')
      ? [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]
      : [];
  }

  function applySections(sections, list) {
    if (!sections) return;
    list.forEach(function (entry) {
      var html = sections[entry.section || entry.id];
      if (!html) return;

      var container =
        document.getElementById(entry.id) ||
        (entry.selector ? document.querySelector(entry.selector) : null);
      if (!container) return;

      var target = (entry.selector && container.querySelector(entry.selector)) || container;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var source =
        (entry.selector && parsed.querySelector(entry.selector)) ||
        parsed.querySelector('.shopify-section');
      if (!source) return;

      target.innerHTML = source.innerHTML;
      neutralizeGiftLinks(target);
    });
  }

  function mutate(url, body) {
    var list = sectionsToRender();
    var ids = list
      .map(function (entry) {
        return entry.section || entry.id;
      })
      .filter(Boolean);

    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }

    return postJSON(url, body).then(function (result) {
      applySections(result.sections, list);
      return result;
    });
  }

  function announce(cartData) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cofa-gift', cartData: cartData });
      }
    } catch (e) {
      /* Temat saknar pubsub – inget att göra. */
    }
  }

  /* ---------------------------------------------------------------- */
  /* Cart guard                                                        */
  /* ---------------------------------------------------------------- */

  async function syncCart(options) {
    options = options || {};
    if (syncing) return null;
    syncing = true;

    try {
      var cart = await getCart();

      /* 1. Bara en presentrad får finnas. Behåll den med hälsning. */
      var lines = giftLines(cart);
      if (lines.length > 1) {
        var keep = lines.filter(hasMessage)[0] || lines[0];
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].key === keep.key) continue;
          await mutate(R.change, { id: lines[i].key, quantity: 0 });
        }
        cart = await getCart();
      }

      /* 2. Presentinslagning ska alltid vara exakt 1. */
      var line = giftLine(cart);
      if (line && line.quantity > 1) {
        await mutate(R.change, { id: line.key, quantity: 1 });
        cart = await getCart();
        line = giftLine(cart);
      }

      /* 3. Bara presentraden kvar – då finns det inget att slå in. */
      if (line && otherUnits(cart) === 0 && !options.skipOrphanCheck) {
        await mutate(R.change, { id: line.key, quantity: 0 });
        cart = await getCart();
      }

      /* 4. Statusflaggan ska spegla verkligheten. */
      var wanted = giftLine(cart) ? cfg.keys.attributeValue : '';
      var current = (cart.attributes && cart.attributes[cfg.keys.attribute]) || '';
      if (wanted !== current) {
        var attributes = {};
        attributes[cfg.keys.attribute] = wanted;
        await mutate(R.update, { attributes: attributes });
        cart = await getCart();
      }

      syncing = false;
      render(cart);
      neutralizeGiftLinks();
      return cart;
    } catch (error) {
      syncing = false;
      if (window.console) console.warn('[cofa-gift]', error);
      return null;
    }
  }

  /* ---------------------------------------------------------------- */
  /* Popup på produktsidan                                             */
  /* ---------------------------------------------------------------- */

  var ui = null;

  function collect() {
    var root = document.querySelector('[data-cofa-gift]');
    if (!root) return null;

    return {
      root: root,
      trigger: root.querySelector('[data-cofa-gift-trigger]'),
      headline: root.querySelector('[data-cofa-gift-headline]'),
      sub: root.querySelector('[data-cofa-gift-sub]'),
      cta: root.querySelector('[data-cofa-gift-cta]'),
      dialog: root.querySelector('[data-cofa-gift-dialog]'),
      title: root.querySelector('[data-cofa-gift-title]'),
      intro: root.querySelector('[data-cofa-gift-intro]'),
      recipient: root.querySelector('[data-cofa-gift-recipient]'),
      recipientLabel: root.querySelector('[data-cofa-gift-recipient-label]'),
      message: root.querySelector('[data-cofa-gift-message]'),
      messageLabel: root.querySelector('[data-cofa-gift-message-label]'),
      counter: root.querySelector('[data-cofa-gift-counter]'),
      note: root.querySelector('[data-cofa-gift-note]'),
      error: root.querySelector('[data-cofa-gift-error]'),
      submit: root.querySelector('[data-cofa-gift-submit]'),
      submitText: root.querySelector('[data-cofa-gift-submit-text]'),
      spinner: root.querySelector('.cofa-gift__spinner'),
      remove: root.querySelector('[data-cofa-gift-remove]'),
      close: root.querySelector('[data-cofa-gift-close]')
    };
  }

  function currentProductSelection() {
    var sectionId = ui.root.getAttribute('data-section-id');
    var scope = (sectionId && document.getElementById('shopify-section-' + sectionId)) || document;
    var form =
      scope.querySelector('product-form form[action*="/cart/add"]') ||
      scope.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return null;

    var qtyInput = scope.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    return { id: idInput.value, quantity: quantity > 0 ? quantity : 1 };
  }

  function updateCounter() {
    if (!ui.counter) return;
    var left = cfg.maxLength - ui.message.value.length;
    ui.counter.textContent = left + ' ' + S.chars;
  }

  function setBusy(busy) {
    ui.submit.disabled = busy;
    if (ui.remove) ui.remove.disabled = busy;
    if (ui.spinner) ui.spinner.hidden = !busy;
  }

  function showError(message) {
    if (!ui.error) return;
    ui.error.textContent = message || S.error;
    ui.error.hidden = false;
  }

  function clearError() {
    if (!ui.error) return;
    ui.error.hidden = true;
    ui.error.textContent = '';
  }

  /* Uppdaterar knapptexter och läge utifrån varukorgens faktiska innehåll. */
  function render(cart) {
    if (!ui) return;

    var added;
    var others;
    var recipient;

    if (cart) {
      var line = giftLine(cart);
      added = !!line;
      others = otherUnits(cart);
      recipient = (line && line.properties && line.properties[cfg.keys.recipient]) || '';
      ui.root.setAttribute('data-state', added ? 'added' : 'idle');
      ui.root.setAttribute('data-others', String(others));
      ui.root.setAttribute('data-recipient', recipient);
    } else {
      added = ui.root.getAttribute('data-state') === 'added';
      others = parseInt(ui.root.getAttribute('data-others') || '0', 10);
      recipient = ui.root.getAttribute('data-recipient') || '';
    }

    if (added) {
      ui.headline.textContent = S.headlineAdded;
      ui.sub.textContent = recipient ? S.to + ' ' + recipient : S.subAdded;
      ui.cta.textContent = S.ctaAdded;
    } else {
      ui.headline.textContent = S.headlineIdle;
      ui.sub.textContent = S.subIdle;
      ui.cta.textContent = cfg.priceFormatted;
    }

    ui.title.textContent = S.title;
    ui.intro.textContent = S.intro;
    ui.recipientLabel.textContent = S.recipientLabel;
    ui.messageLabel.textContent = S.messageLabel;
    ui.recipient.placeholder = S.recipientPlaceholder;
    ui.message.placeholder = S.messagePlaceholder;
    ui.close.setAttribute('aria-label', S.close);
    ui.note.textContent = !added && others === 0 ? S.emptyNote : S.addressNote;

    if (added) {
      ui.submitText.textContent = S.save;
    } else if (others === 0) {
      ui.submitText.textContent = S.addWithProduct + ' – ' + cfg.priceFormatted;
    } else {
      ui.submitText.textContent = S.add + ' – ' + cfg.priceFormatted;
    }

    if (ui.remove) {
      ui.remove.hidden = !added;
      ui.remove.textContent = S.remove;
    }

    updateCounter();
  }

  function openDialog() {
    clearError();
    render(null);

    if (typeof ui.dialog.showModal === 'function') {
      ui.dialog.showModal();
    } else {
      ui.dialog.setAttribute('open', '');
    }

    /* Hämta färska värden från varukorgen så popupen alltid är förifylld rätt. */
    getCart().then(function (cart) {
      var line = giftLine(cart);
      if (line && line.properties) {
        ui.recipient.value = line.properties[cfg.keys.recipient] || '';
        ui.message.value = line.properties[cfg.keys.message] || '';
      }
      render(cart);
      window.setTimeout(function () {
        ui.recipient.focus();
      }, 50);
    });
  }

  function closeDialog() {
    if (typeof ui.dialog.close === 'function' && ui.dialog.open) {
      ui.dialog.close();
    } else {
      ui.dialog.removeAttribute('open');
    }
  }

  async function onSubmit() {
    clearError();
    setBusy(true);

    var properties = {};
    properties[cfg.keys.message] = clean(ui.message.value, cfg.maxLength);
    properties[cfg.keys.recipient] = clean(ui.recipient.value, 60);

    try {
      var cart = await getCart();
      var line = giftLine(cart);

      if (line) {
        await mutate(R.change, { id: line.key, quantity: 1, properties: properties });
      } else {
        var items = [];
        if (otherUnits(cart) === 0) {
          var selection = currentProductSelection();
          if (selection) items.push({ id: Number(selection.id), quantity: selection.quantity });
        }
        items.push({ id: Number(cfg.variantId), quantity: 1, properties: properties });
        await mutate(R.add, { items: items });
      }

      var fresh = await syncCart({ skipOrphanCheck: true });
      announce(fresh);
      setBusy(false);
      closeDialog();
    } catch (error) {
      setBusy(false);
      showError(error && error.message ? error.message : S.error);
      if (window.console) console.warn('[cofa-gift]', error);
    }
  }

  async function onRemove() {
    clearError();
    setBusy(true);

    try {
      var cart = await getCart();
      var lines = giftLines(cart);
      for (var i = 0; i < lines.length; i++) {
        await mutate(R.change, { id: lines[i].key, quantity: 0 });
      }

      var fresh = await syncCart();
      announce(fresh);
      setBusy(false);
      closeDialog();
    } catch (error) {
      setBusy(false);
      showError(S.error);
      if (window.console) console.warn('[cofa-gift]', error);
    }
  }

  function initUI() {
    ui = collect();
    if (!ui) return;

    render(null);

    ui.trigger.addEventListener('click', openDialog);
    ui.close.addEventListener('click', closeDialog);
    ui.submit.addEventListener('click', onSubmit);
    if (ui.remove) ui.remove.addEventListener('click', onRemove);
    ui.message.addEventListener('input', updateCounter);

    /* Klick på backdrop stänger. */
    ui.dialog.addEventListener('click', function (event) {
      if (event.target === ui.dialog) closeDialog();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Start                                                             */
  /* ---------------------------------------------------------------- */

  function boot() {
    initUI();
    neutralizeGiftLinks();

    /* Synka bara om det finns något att synka – sparar ett anrop för de flesta. */
    var needsSync =
      !!ui &&
      (ui.root.getAttribute('data-state') === 'added' ||
        (ui.root.getAttribute('data-attribute') || '') !== '');

    if (needsSync) syncCart();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        neutralizeGiftLinks();
        if (event && event.source === 'cofa-gift') return;
        syncCart();
      });
    }

    /* Temat renderar om draveren utan att alltid publicera cartUpdate. */
    var drawer = document.getElementById('CartDrawer');
    if (drawer && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        neutralizeGiftLinks(drawer);
      }).observe(drawer, { childList: true, subtree: true });
    }

    /* Bakåtnavigering från bfcache visar annars gammalt läge. */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) syncCart();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
